/* DON'T EDIT THIS FILE: edit original and run build again */ import { emailVerifyTokenType } from "./email-verify-token-code.ts";

export const verifyEmailRequiredActionId = emailVerifyTokenType;
